<template>
  <div>
    <div @click="handleGetColumnByTable(table,index)"
         :class="`table-filter-nav-item ${index===selectedIndex?'table-filter-nav-item-selected':''}`"
         v-for="(table,index) in showTableList" :key="index">
      <div class="table-filter-nav-item-arrow"></div>
      <div class="table-filter-nav-item-db" v-if="type==='sink'">
        <p><i class="iconfont iconbiao"></i>{{ table.sourceDb }}.{{ table.sourceTable }}</p>
        <img class="table-filter-nav-item-arrow" src="../../../../../assets/jiantou01.png" alt="arrow">
        <p style="word-break: break-all" :class="table.needAutoCreated?'db-to-create':''">
          <i :class="`iconfont ${table.needAutoCreated?'icontopic':'icontopic'}`"></i>
          <span>{{
              table.sinkTable === 'cloudCanal_default' && table.customSinkTable ? table.customSinkTable : table.sinkTable || table.targetTable
            }}</span>
        </p>
        <div class="chosed-count" style="display: flex;justify-content: space-between;padding-right: 20px;">
          <div>
            {{ $t('yi-xuan-zhong') }}<span
            :class="getSelectedInfo(table.sourceDb,table.sourceTable).selectedCount<
                    (selectedColumns[table.sourceDb][table.sourceTable]?selectedColumns[table.sourceDb][table.sourceTable].length:0)?'warn-count':''"
            style="text-align: center;display: inline-block;">
                  {{ getSelectedInfo(table.sourceDb, table.sourceTable).selectedCount }}</span>
            /{{selectedColumns[table.sourceDb][table.sourceTable] ? selectedColumns[table.sourceDb][table.sourceTable].length : '0' }}{{ $t('ge-lie') }}
            <span style="margin-left: 10px"><span style="margin-right: 4px">{{ $t('fen-qu-shu') }}</span><span>{{ table.partitions }}</span>
                      <i v-if="table.needAutoCreated||taskInfo.processType==='edit'" style="margin-left: 8px;cursor: pointer"
                         @click="handleSetPartition(table)"
                         class="iconfont iconeditwhere"></i></span>
          </div>
          <Dropdown transfer trigger="click">
            <a href="javascript:void(0)" class="dropdown-content">
              {{ $t('cao-zuo') }}
              <Icon type="ios-arrow-down"></Icon>
            </a>
            <DropdownMenu slot="list" class="table-operation-dropdown">
              <DropdownItem  v-if="supportVirtualColumn && !table.hasInJob" class="table-operation-dropdown">
                <a class="dropdown-content"
                   style="color: #333333"
                   @click="handleShowVirtualColumn(table)">
                  {{ $t('xu-ni-lie') }}</a>
              </DropdownItem>
              <DropdownItem v-if="supportSpecifiedKeys">
                <a
                  style="color: #333333"
                  class="dropdown-content"
                  @click="handleChangePk(table)">
                  {{ $t('mu-biao-zhu-jian') }}</a>
              </DropdownItem>
              <DropdownItem>
                <a style="color: #333" class="dropdown-content"
                   :class="getWhereCondition(table)?'has-where-table':''"
                   @click="handleFilter(table)">
                  {{ $t('getwhereconditiontable-xiu-gai-tian-jia-where-tiao-jian', [getWhereCondition(table) ? $t('xiu-gai') : $t('tian-jia')]) }}</a>
              </DropdownItem>
              <DropdownItem v-if="sinkType==='ElasticSearch'">
                <a class="dropdown-content"
                   style="color: #333333;margin-right: 5px;"
                   @click="handleSetId(table)"
                >
                  {{$t('she-zhi-id-zhi')}}
                </a>
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>
      <div class="table-filter-nav-item-db" v-if="type==='source'">
        <p><i class="iconfont icontopic"></i>{{ table.sourceTable }}</p>
        <img class="table-filter-nav-item-arrow" src="../../../../../assets/jiantou01.png" alt="arrow">
        <p style="word-break: break-all" :class="table.needAutoCreated?'db-to-create':''">
          <i :class="`iconfont ${table.needAutoCreated?'iconbiao':'iconbiao'}`"></i>
          <span><span
            v-if="table.sinkDb">{{
              table.sinkDb
            }}.</span>{{
              table.sinkTable === 'cloudCanal_default' && table.customSinkTable ? table.customSinkTable : table.sinkTable
            }}</span>
        </p>
        <div class="chosed-count" style="display: flex;justify-content: space-between;padding-right: 20px;">
          <div>
            {{ $t('yi-xuan-zhong') }}
            <span
              :class="getSelectedInfo(table.sinkDb,table.sinkTable).selectedCount<
                (selectedColumns[table.sinkDb][table.sinkTable]?selectedColumns[table.sinkDb][table.sinkTable].length:0)?'warn-count':''"
              style="text-align: center;display: inline-block;">
              {{ getSelectedInfo(table.sinkDb, table.sinkTable).selectedCount }}
          </span>
            /{{
              selectedColumns[table.sinkDb][table.sinkTable] ? selectedColumns[table.sinkDb][table.sinkTable].length : '0'
            }}{{ $t('ge-lie') }}
          </div>
          <Dropdown transfer trigger="click" v-if="isKafka(sourceType)&&(isMySQL(sinkType)||isStarRocks(sinkType)||isES(sinkType))">
            <a href="javascript:void(0)">
              {{ $t('cao-zuo') }}
              <Icon type="ios-arrow-down"></Icon>
            </a>
            <DropdownMenu slot="list">
              <DropdownItem v-if="supportSpecifiedKeys">
                <a
                  style="color: #333333"
                  class="dropdown-content"
                  @click="handleChangePk(table)">
                  {{ $t('mu-biao-zhu-jian') }}</a>
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataSourceGroup from '@/views/dataSourceGroup';
import {
  isES, isKafka, isMySQL, isStarRocks
} from '@/utils';

export default {
  methods: { isES },
  props: {
    handleSetId: Function,
    taskInfo: Object,
    handleGetColumnByTable: Function,
    selectedIndex: Number,
    showTableList: Array,
    getSelectedInfo: Function,
    getWhereCondition: {
      prop: Function,
      default: null
    },
    sourceType: String,
    sinkType: String,
    handleFilter: Function,
    selectedColumns: Object,
    handleSetPartition: Function,
    type: String,
    handleChangePk: Function,
    theType: String,
    supportVirtualColumn: Boolean,
    handleShowVirtualColumn: Function,
    supportSpecifiedKeys: Boolean
  },
  data() {
    return {
      DataSourceGroup,
      isKafka,
      isMySQL,
      isStarRocks
    };
  }
};
</script>
<style lang="less">
.operation {
  &:hover {
    color: #0BB9F8!important;
  }
  position: absolute;
  right: 100px;
  color: #333333;
}
.table-operation-dropdown .ivu-dropdown-item {
  padding: 0!important;
}

.dropdown-content {
  padding: 7px 16px;
  display: block;
}
</style>
